import { isDuApp, isIOS } from "@/utils/appUtils/getDevice";
import Jockeys from "@/utils/jockey";
import { YBackGroundImage } from "@/utils/style-methods";
import { Component } from "react";
import styles from '../index.module.less'
import { countTimeTxt1, countTimeTxt2, countTimeTxt3, getLimit, rule } from "../config/lang";
import { imgResource } from "../config/resource";
import { IPageColor } from "../typing";
import { withReactTrack } from "@du/analytics-sdk";
import { createTrackConfig } from '../config/track-config'
import appInstall from "@/utils/appUtils/appInstall";

interface ITimeCountDownProps {
    deductionAmount: number;
    expireTime: number;
    expired: boolean;
    lang: string;
    region: string;
    limitAmount: number;
    couponType: number;
    ruleUrl: string;
    pageColor: IPageColor;
    tabBgColor: string;
}

interface ITimeCountDownState {
    fixed: boolean
    day: number;
    hours: number;
    min: number;
    seconds: number;
    renderTimeStatus: boolean;
    statusAdd: number;
}

// todo: 动画再补充
@withReactTrack({ createTrackConfig })
export default class TimeCountDown extends Component<ITimeCountDownProps, ITimeCountDownState> {
    constructor(prop: ITimeCountDownProps) {
        super(prop)
        this.state = {
            fixed: false,
            statusAdd: 0,
            ...this.caculateStr(),
        }
    }

    intersectionObserver: IntersectionObserver

    interval: NodeJS.Timeout

    listenRoot: HTMLDivElement

    caculateStr() {
        // 这里就暂时不为了一个时间计算引入moment了
        const { expireTime } = this.props
        const rest = expireTime - Date.now()
        // console.log(rest)
        if (rest < 0) {
            return {
                day: 0,
                hours: 0,
                min: 0,
                seconds: 0,
                renderTimeStatus: false,
            }
        }

        const day = Math.floor(rest / 1000 / 3600 / 24)
        const hours = Math.floor(rest / 1000 / 3600 - 24 * day)
        const min = Math.floor(rest / 1000 / 60  - 24 * 60 * day - hours * 60)
        const seconds = Math.floor(rest / 1000 - 24 * 60 * 60 * day - hours * 3600 - min * 60)
        
        return {
            day: day < 0 ? 0 : day,
            hours: hours < 0 ? 0 : hours,
            min: min < 0 ? 0 : min,
            seconds: seconds < 0 ? 0 : seconds,
            renderTimeStatus: true,
        }
    }

    tick() {
        this.setState(() => {
            const timeCal = this.caculateStr();
            if (!timeCal.renderTimeStatus) {
                if (this.intersectionObserver) {
                    this.clear()
                }
            }
            return timeCal;
        })
    }

    componentDidMount() {
        this.interval = setInterval(() => this.tick(), 100);

        Jockeys.getPlatformInfoCallback((d) => {
            console.log(d, 'd')
            this.setState({
                statusAdd: d.statusBarHeight
            })
        })
        Jockeys.getPlatformInfo()
        this.startListen();
    }

    componentWillUnmount() {
        this.clear()
    }

    clear() {
        clearInterval(this.interval);
        if (this.intersectionObserver) {
            this.intersectionObserver.unobserve(this.listenRoot);
        }
    }

    goToRule() {
        const {ruleUrl} = this.props;
        
        (this as any).$track('poizon_activity_sign_block_click')

        if (isDuApp()) {
            Jockeys.openNativePage('/web/browser', { url: ruleUrl })
        } else {
            appInstall('/web/browser', { ruleUrl })
        }
    }

    // 监听 topArea 从屏幕中消失，options全部为默认值
    startListen() {
        this.listenRoot = document.querySelector('#time-count-down');

        this.intersectionObserver = new IntersectionObserver((entries) => {
            if (entries[0].intersectionRatio === 0) {
                this.setState({
                    fixed: true,
                });
            } else {
                this.setState({
                    fixed: false,
                });
            }
        })
        if (this.intersectionObserver) {
            this.intersectionObserver.observe(this.listenRoot);
        }   
    }

    timeRender(color, background, bool = true) {
        const { lang } = this.props
        const { day, hours, min, seconds, renderTimeStatus } = this.state;

        const backIcon = YBackGroundImage(imgResource["back-icon"], [{
            mode: 'resize',
            width: 2 * 21
        }])

        const issueColor = { color }
        const backColor = { background }

        return (
            <span className={styles['time-render']} style={issueColor}>
                {
                    renderTimeStatus
                        ? (
                            <>
                                <span className={styles['time-render-text']}>{countTimeTxt1[lang]}</span>
                                <span className={styles['time-render-time']}>
                                    <span className={styles['time-render-number']} style={backColor}>{day}</span>
                                    {/* 特殊的如果是英文 */}
                                    { day > 1 && lang === 'en' ? countTimeTxt2[lang] + 's': countTimeTxt2[lang]}
                                    <span className={styles['time-render-number']} style={backColor}>{hours}</span>
                                    :
                                    <span className={styles['time-render-number']} style={backColor}>{min}</span>
                                    :
                                    <span className={styles['time-render-number']} style={backColor}>{seconds}</span>
                                </span>
                                <span className={styles['time-render-rule']} onClick={() => this.goToRule()}>
                                    {bool ? rule[lang] : ''}
                                    <span className={styles['time-render-icon']} style={{...backIcon}}></span>
                                </span>
                            </>
                        )
                        : (
                            <>
                                <span className={styles['time-render-text']}>{countTimeTxt3[lang]}</span>
                                <span className={styles['time-render-rule']} onClick={() => this.goToRule()}>
                                    {rule[lang]}
                                    <span className={styles['time-render-icon']} style={{...backIcon}}></span>
                                </span>
                            </>
                        )
                }
            </span>
        );
    }

    render() {
        const { lang, region, limitAmount, couponType, deductionAmount, pageColor, expired, tabBgColor } = this.props;
        const { fixed, statusAdd } = this.state;
        const pxTorem = (px: number) => {
            return `${px/100}rem`
        }

        const statusBarHeight = statusAdd

        const fixedAreaBackColor = {
            background: tabBgColor,
            // 8 8 顶部条，24为高度，6为经验值
            top: isDuApp() ? pxTorem(statusBarHeight + 24 + 8 + 8 + 6) : pxTorem(0),
        }

        const timeAreaBackColor = {
            background: pageColor.couponFixedBackColor,
        }

        return (
            <div>
                <div id="time-count-down" className={styles['time-count-down']}>
                    {this.timeRender(pageColor.countTimeColor, pageColor.countTimeBackColor)}
                </div>
                { 
                    fixed && !expired
                        ? (
                            <div className={styles['fixed-time-count']} style={fixedAreaBackColor}>
                                <div className={styles['fixed-time-count-box']} style={timeAreaBackColor}>
                                    {/* 这里取最大面额的可用 */}
                                    {/* <span style={{color: pageColor.countTimeFixedColor}}>{getLimit(lang, region, limitAmount, couponType, deductionAmount)}</span> */}
                                    {this.timeRender(pageColor.countTimeFixedColor, pageColor.countTimeFixedBackColor, false)}
                                </div>
                            </div>
                        )
                        : ''
                }
            </div>
        )
    }
}